// TEMPORARY Service Worker that deletes old precaches. We removed precaching, but the old caches haven't been removed
// and are causing white screens in some cases. We might want to remove this after it's run on PROD for a while, but
// since caches seem to persist for an indefinite amount of time, maybe we should leave it running for a while
class SW {
  static init() {
    if ("serviceWorker" in navigator && window.location.hostname !== "localhost") {
      window.addEventListener("load", () => {
        navigator.serviceWorker
          .register(new URL("sw.js", import.meta.url))
          .then((registration) => {
            console.log("SW registered: ", registration);
          })
          .catch((registrationError) => {
            console.log("SW registration failed: ", registrationError);
          });
      });
    }
  }
}

export { SW as default };
